// Mirrors the backend's urlSafety rules (functions/src/track/urlSafety.ts)
// so users get instant feedback before the API rejects a bad URL.
export function normalizeRedirectUrl(rawUrl) {
  if (typeof rawUrl !== "string") return null;

  const trimmed = rawUrl.trim();
  if (!trimmed) return null;

  const hasScheme = /^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(trimmed);
  const candidate = hasScheme
    ? trimmed
    : `https://${trimmed.replace(/^\/+/, "")}`;

  let parsed;
  try {
    parsed = new URL(candidate);
  } catch {
    return null;
  }

  if (parsed.protocol !== "https:" && parsed.protocol !== "http:") {
    return null;
  }
  if (!parsed.hostname || !parsed.hostname.includes(".")) {
    return null;
  }

  return parsed.toString();
}

export function isPlainHttp(rawUrl) {
  const normalized = normalizeRedirectUrl(rawUrl);
  return normalized !== null && normalized.startsWith("http://");
}

export function buildTrackingUrl(campaignId, strategyId, utmParams = {}) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(utmParams)) {
    if (value) params.append(key, value);
  }
  const query = params.toString();
  const base = `${window.location.origin}/track/${campaignId}/${strategyId}`;
  return query ? `${base}?${query}` : base;
}
